import axios from 'axios';
import { promiseSettled } from '@/utils/promiseAction';
import { swalAlert } from '@/utils/swal';
import { encrypteTarget } from '@/utils/crypto';
import { setItemWithExpiry } from '@/utils/storage';

// 로그인 API
export const login = async (loginData) => {
  try {
    const response = await axios.post('/nosp/login', loginData);
    return response.data;
  } catch (error) {
    console.error('Login API Error:', error);
    return {
      status: 'error',
      message: '로그인 요청 중 오류가 발생했습니다.'
    };
  }
};

// 로그인 처리 함수
export const doLogin = async (router, loginInput) => {
  try {
    let requests = [];
    requests.push(login(loginInput));
    
    const result = await promiseSettled(requests);
    
    result.forEach(data => {
      const { success, value } = data;
      
      if (success) {
        if (value.status === 'success') {
          // 사용자 정보 저장 - 세션키 생성
          const sessionKey = generateSessionKey();
          const userInfo = {
            ...value.user,
            sessionKey: sessionKey
          };
          
          setLogin(userInfo);
          router.push('/inventory');
        } else {
          swalAlert(value.message || '로그인에 실패했습니다.', 'warning');
        }
      } else {
        swalAlert('오류가 발생했습니다. 관리자에게 문의 부탁드립니다.', 'warning');
      }
    });
  } catch (error) {
    console.error('Login process error:', error);
    swalAlert('오류가 발생했습니다. 관리자에게 문의 부탁드립니다.', 'warning');
  }
};

// 세션 키 생성
const generateSessionKey = () => {
  return 'sess_' + Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15) + 
         Date.now().toString(36);
};

// 세션 키 설정
const setSessionKey = (sessionKey) => {
  localStorage.setItem('userSessionKey', sessionKey);
};

// 로그인 정보 설정
export const setLogin = (_userInfo) => {
  const userInfo = {
    value: {}
  };
  
  console.log('nosp inventory userInfo', _userInfo);
  const expiry = 1; // 1일

  userInfo.value = {};
  localStorage.removeItem('userInfo');
  localStorage.removeItem('userSessionKey');

  userInfo.value.isUserLogin = true;

  // sessionKey 값을 제외한 나머지 데이터만 추출
  const { sessionKey, ...restUserInfo } = _userInfo;
  userInfo.value.data = encrypteTarget(JSON.stringify(restUserInfo));
  setSessionKey(sessionKey);
  setItemWithExpiry('userInfo', userInfo.value, expiry);
  
  return userInfo;
};

// 로그아웃 처리
export const logout = (router) => {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('userSessionKey');
  router.push('/login');
}; 